export default {
  isAuthenticated: (state) => state.isLogged,
  getToken: (state) => state.token,
  isTransactionSuccess: (state) => state.isSucceeded,
  getErrors: (state) => () => {
    return {
      errorMessage: state.errorMessage,
      validationErrors: state.validationErrors,
    };
  },
};
